/**
 * Reusable name/price form for the "Planes" catalog (Task 11), used both for
 * the always-visible create form at the top of `PlansPage` and for the
 * inline edit form a row switches to. Deliberately "dumb": it holds no state
 * of its own — `values`/`submitting`/`error` are owned by the parent and
 * `onChange`/`onSubmit` are forwarded verbatim — so `PlansPage` is the single
 * place that decides what happens with a submission (call the API, reload
 * the catalog, close the edit) without this component racing it.
 *
 * `price` is a plain `type="text"` input, never `type="number"`: the browser
 * must never reformat, clamp, or silently reject what the admin types (a
 * comma, three decimals, a leading zero) before it reaches `onChange`. The
 * server is the only validator of the value (spec: "el cliente sólo
 * presenta DTOs"); this form's job is to carry the string through untouched.
 */
export function PlanForm({
  formLabel,
  idPrefix,
  values,
  onChange,
  onSubmit,
  submitting,
  error,
  submitLabel,
  submittingLabel,
  onCancel,
}) {
  const nameId = `${idPrefix}-name`;
  const priceId = `${idPrefix}-price`;

  return (
    <form className="gym-form gym-plan-form" aria-label={formLabel} onSubmit={onSubmit} noValidate>
      {error && <p role="alert" className="gym-form__error">{error}</p>}

      <div className="gym-field">
        <label htmlFor={nameId} className="gym-field__label">Nombre</label>
        <input
          id={nameId}
          name="name"
          type="text"
          required
          value={values.name}
          disabled={submitting}
          onChange={(event) => onChange('name', event.target.value)}
          className="gym-input"
        />
      </div>

      <div className="gym-field">
        <label htmlFor={priceId} className="gym-field__label">Precio</label>
        <input
          id={priceId}
          name="price"
          type="text"
          inputMode="decimal"
          required
          value={values.price}
          disabled={submitting}
          onChange={(event) => onChange('price', event.target.value)}
          className="gym-input"
        />
      </div>

      <div className="gym-plan-form__actions">
        <button type="submit" disabled={submitting} className="gym-button gym-button--primary">
          {submitting ? submittingLabel : submitLabel}
        </button>
        {onCancel && (
          <button type="button" className="gym-button gym-button--secondary" onClick={onCancel} disabled={submitting}>
            Cancelar
          </button>
        )}
      </div>
    </form>
  );
}
